// // SignupForm.js - Complete with registration event tracking, booking form support, and Turnstile CAPTCHA
// import Login from "modals/Login";
// import { useDispatch } from "react-redux";
// import { useState, useEffect, useCallback, useRef } from "react";
// import { useNavigate } from "react-router";
// import { register, completeSocialRegistration } from "store/auth/thunks";
// import { Checkbox } from "reusableComponents";
// import { useTranslation } from "react-i18next";
// import { useLanguage, useModal } from "context";
// import { useConsent } from "context/ConsentContext";
// import SignUpFormInputs from "./SignUpFormInputs";
// import { validateField } from "helpers/validation";
// import { gtm } from "GTM";
// import styles from "./styles.module.scss";
// import i18next from "i18next";
// // ADDED: Import Turnstile component - COMMENTED OUT
// // import { Turnstile } from "@marsidev/react-turnstile";

// // Helper: Get or create session ID (stored in sessionStorage only)
// const getOrCreateSessionId = () => {
//   let sessionId = sessionStorage.getItem('gtm_functional_session_id');
//   if (!sessionId) {
//     sessionId = 'func_sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
//     sessionStorage.setItem('gtm_functional_session_id', sessionId);
//   }
//   return sessionId;
// };

// // Helper: Hash email for security tracking without storing PII
// const hashEmail = (email) => {
//   if (!email) return null;
//   let hash = 0;
//   for (let i = 0; i < email.length; i++) {
//     const char = email.charCodeAt(i);
//     hash = ((hash << 5) - hash) + char;
//     hash = hash & hash;
//   }
//   return Math.abs(hash).toString(16);
// };

// const getCurrentLanguage = () => {
//   if (typeof window === 'undefined') return 'en';
  
//   const hostname = window.location.hostname;
  
//   // Domain-based language detection
//   if (hostname.includes('.fr')) return 'fr';
//   if (hostname.includes('.es')) return 'es';
//   if (hostname.includes('.be')) return 'fr';
//   if (hostname.includes('.uk')) return 'en';
//   if (hostname.includes('.com')) return 'en';
  
//   // Fallback to i18next
//   if (i18next.language) {
//     if (i18next.language === 'uk') return 'en';
//     return i18next.language === 'be' ? 'fr' : i18next.language;
//   }
  
//   return 'en';
// };

// const SignupForm = ({ type = "seeker", forBookingForm = false, spaceId = null, returnUrl = null, onSuccess = null }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { language } = useLanguage();
//   const [t] = useTranslation("global");
//   const { openModal, closeModal } = useModal();
//   const { hasConsent } = useConsent();
//   const [cgu, setCgu] = useState(false);
//   const [accountType, setAccountType] = useState(() => {
//     if (type === "provider") {
//       return { label: t("modal.register.businessAccount"), value: "company" };
//     }
//     return null;
//   });
//   const [newsletter, setNewsletter] = useState(false);
//   const [inputValues, setInputValues] = useState({});
//   const [errors, setErrors] = useState([]);
//   const [generalErrors, setGeneralErrors] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [touchedFields, setTouchedFields] = useState({});
//   const [googleRegistrationData, setGoogleRegistrationData] = useState(null);
  
//   // ADDED: Turnstile state - COMMENTED OUT
//   // const [captchaToken, setCaptchaToken] = useState(null);
//   // const [captchaError, setCaptchaError] = useState(false);
//   // const turnstileRef = useRef(null);
  
//   // TEMPORARY: Set dummy token for testing
//   const [captchaToken, setCaptchaToken] = useState('dummy_captcha_token_for_testing');
//   const [captchaError, setCaptchaError] = useState(false);
//   const turnstileRef = useRef(null);

//   const getRedirectUri = useCallback(() => {
//     if (typeof window === 'undefined') return '';
//     return `${window.location.origin}/auth/auth-endpoint`;
//   }, []);

//   // Helper to clear any existing pending booking data - ONLY for non-booking forms
//   const clearPendingBookingData = useCallback(() => {
//     if (!forBookingForm) {
//       sessionStorage.removeItem('pending_booking_data');
//       sessionStorage.removeItem('google_oauth_state');
//       sessionStorage.removeItem('google_registration_data');
//       sessionStorage.removeItem('signup_booking_context');
//       sessionStorage.removeItem('just_registered_for_booking');
//       sessionStorage.removeItem('booking_space_id');
//       console.log('[SignupForm] Cleared pending booking data (non-booking form)');
//     } else {
//       console.log('[SignupForm] Preserving pending booking data for booking form');
//     }
//   }, [forBookingForm]);

//   // Store booking form context for Google OAuth redirect
//   useEffect(() => {
//     if (forBookingForm && spaceId) {
//       if (!forBookingForm) {
//         clearPendingBookingData();
//       }
      
//       sessionStorage.setItem('signup_booking_context', JSON.stringify({
//         spaceId,
//         returnUrl: returnUrl || `/space/${spaceId}`,
//         timestamp: Date.now(),
//         forBookingForm: true
//       }));
//     }
//   }, [forBookingForm, spaceId, returnUrl, clearPendingBookingData]);

//   // Handle Google OAuth callback for signup
//   useEffect(() => {
//     const storedData = sessionStorage.getItem('google_registration_data');
//     const code = new URLSearchParams(window.location.search).get('code');
    
//     if (code && !storedData && !googleRegistrationData) {
//       const handleGoogleSignupCallback = async () => {
//         setLoading(true);
//         try {
//           const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
//           const redirectUri = getRedirectUri();
          
//           const tokenResponse = await fetch('https://oauth2.googleapis.com/token', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/x-www-form-urlencoded',
//             },
//             body: new URLSearchParams({
//               code: code,
//               client_id: clientId,
//               client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
//               redirect_uri: redirectUri,
//               grant_type: 'authorization_code',
//             }),
//           });
          
//           const tokenData = await tokenResponse.json();
          
//           if (tokenData.access_token) {
//             const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
//               headers: {
//                 Authorization: `Bearer ${tokenData.access_token}`,
//               },
//             });
            
//             const userData = await userInfoResponse.json();
            
//             sessionStorage.setItem('google_registration_data', JSON.stringify({
//               userData: {
//                 email: userData.email,
//                 first_name: userData.given_name,
//                 last_name: userData.family_name,
//                 google_id: userData.id,
//                 google: userData.id
//               },
//               provider: 'google'
//             }));
            
//             window.history.replaceState({}, document.title, window.location.pathname);
            
//             setGoogleRegistrationData({
//               userData: {
//                 email: userData.email,
//                 first_name: userData.given_name,
//                 last_name: userData.family_name,
//                 google_id: userData.id,
//                 google: userData.id
//               },
//               provider: 'google'
//             });
            
//             setInputValues({
//               email: userData.email || '',
//               first_name: userData.given_name || '',
//               last_name: userData.family_name || '',
//             });
            
//             const firstName = userData.given_name || '';
//             const welcomeMessage = firstName 
//               ? t("modal.register.welcomeGoogleWithName", { name: firstName })
//               : t("modal.register.welcomeGoogle");
            
//             setGeneralErrors([{ 
//               type: 'success',
//               message: welcomeMessage
//             }]);
//           }
//         } catch (error) {
//           console.error('Google signup callback error:', error);
//           setGeneralErrors([{ type: 'error', message: t("modal.register.googleSignupError") }]);
//         } finally {
//           setLoading(false);
//         }
//       };
      
//       handleGoogleSignupCallback();
//     } else if (storedData && !googleRegistrationData) {
//       try {
//         const data = JSON.parse(storedData);
//         console.log('[SignupForm] Google registration data found:', data);
        
//         const userData = data.userData;
//         const googleId = userData.google || userData.google_id || userData.sub;
        
//         if (!googleId) {
//           console.error('[SignupForm] No Google ID found');
//           sessionStorage.removeItem('google_registration_data');
//           return;
//         }
        
//         setGoogleRegistrationData({
//           ...data,
//           userData: {
//             ...userData,
//             google_id: googleId,
//             google: googleId
//           }
//         });
        
//         setInputValues({
//           email: userData.email || '',
//           first_name: userData.first_name || '',
//           last_name: userData.last_name || '',
//         });
        
//         const firstName = userData.first_name || '';
//         const welcomeMessage = firstName 
//           ? t("modal.register.welcomeGoogleWithName", { name: firstName })
//           : t("modal.register.welcomeGoogle");
        
//         setGeneralErrors([{ 
//           type: 'success',
//           message: welcomeMessage
//         }]);
        
//       } catch (e) {
//         console.error('[SignupForm] Error parsing Google data:', e);
//         sessionStorage.removeItem('google_registration_data');
//       }
//     }
//   }, [getRedirectUri, t]);

//   const handleGoogleSignupClick = () => {
//     if (loading) return;
    
//     if (!forBookingForm) {
//       clearPendingBookingData();
//     }
    
//     const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
//     const redirectUri = getRedirectUri();
    
//     if (!clientId) {
//       setGeneralErrors([{ type: 'error', message: t("modal.register.googleConfigError") }]);
//       return;
//     }

//     sessionStorage.setItem('google_oauth_intent', 'signup');
//     sessionStorage.setItem('google_signup_type', type);
    
//     if (forBookingForm && spaceId) {
//       sessionStorage.setItem('signup_booking_context', JSON.stringify({
//         spaceId,
//         returnUrl: returnUrl || `/space/${spaceId}`,
//         timestamp: Date.now(),
//         forBookingForm: true
//       }));
//     }
    
//     const state = JSON.stringify({
//       token: 'google_oauth_' + Math.random().toString(36).substring(7),
//       timestamp: Date.now(),
//       intent: 'signup',
//       userType: type,
//       forBookingForm: forBookingForm,
//       spaceId: spaceId,
//       returnUrl: returnUrl
//     });
    
//     sessionStorage.setItem('google_oauth_state', state);

//     const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
//     authUrl.searchParams.append('client_id', clientId);
//     authUrl.searchParams.append('redirect_uri', redirectUri);
//     authUrl.searchParams.append('response_type', 'code');
//     authUrl.searchParams.append('scope', 'email profile openid');
//     authUrl.searchParams.append('access_type', 'online');
//     authUrl.searchParams.append('prompt', 'consent');
//     authUrl.searchParams.append('state', state);

//     window.location.href = authUrl.toString();
//   };

//   const handleInputChange = useCallback((name, value) => {
//     setInputValues((prev) => ({ ...prev, [name]: value }));
    
//     setErrors((prevErrors) => prevErrors.filter(err => err.code !== name));
    
//     if (touchedFields[name]) {
//       const errorMessage = validateField(
//         name, 
//         value, 
//         t, 
//         { ...inputValues, [name]: value }, 
//         type, 
//         accountType?.value
//       );
//       if (errorMessage) {
//         setErrors((prevErrors) => {
//           const existing = prevErrors.find(err => err.code === name);
//           if (existing) {
//             return prevErrors.map(err => err.code === name ? { ...err, message: errorMessage } : err);
//           }
//           return [...prevErrors, { code: name, message: errorMessage }];
//         });
//       }
//     }
//   }, [touchedFields, inputValues, t, type, accountType]);

//   const handleInputBlur = useCallback((name, value) => {
//     setTouchedFields((prev) => ({ ...prev, [name]: true }));
//     const errorMessage = validateField(name, value, t, inputValues, type, accountType?.value);
    
//     if (errorMessage) {
//       setErrors((prevErrors) => {
//         const existing = prevErrors.find(err => err.code === name);
//         if (existing) {
//           return prevErrors.map(err => err.code === name ? { ...err, message: errorMessage } : err);
//         }
//         return [...prevErrors, { code: name, message: errorMessage }];
//       });
//     } else {
//       setErrors((prevErrors) => prevErrors.filter(err => err.code !== name));
//     }
//   }, [inputValues, t, type, accountType]);

//   // ADDED: Turnstile callback handlers - COMMENTED OUT
//   // const handleCaptchaSuccess = useCallback((token) => {
//   //   console.log('[SignupForm] Turnstile token received');
//   //   setCaptchaToken(token);
//   //   setCaptchaError(false);
//   // }, []);
//   //
//   // const handleCaptchaError = useCallback(() => {
//   //   console.error('[SignupForm] Turnstile error');
//   //   setCaptchaError(true);
//   //   setCaptchaToken(null);
//   // }, []);
//   //
//   // const handleCaptchaExpire = useCallback(() => {
//   //   console.log('[SignupForm] Turnstile token expired');
//   //   setCaptchaToken(null);
//   //   // Show a message to the user that they need to complete the CAPTCHA again
//   //   setGeneralErrors((prev) => {
//   //     const filtered = prev.filter(err => err.type !== 'captcha');
//   //     return [...filtered, { 
//   //       type: 'error', 
//   //       message: t("modal.register.captcha.expired") 
//   //     }];
//   //   });
//   // }, [t]);

//   // ADDED: Reset captcha on 422 error - COMMENTED OUT
//   // const resetCaptcha = useCallback(() => {
//   //   if (turnstileRef.current) {
//   //     // Reset the Turnstile widget
//   //     turnstileRef.current.reset();
//   //   }
//   //   setCaptchaToken(null);
//   //   setCaptchaError(false);
//   // }, []);

//   const validateGoogleRegistrationForm = () => {
//     const validationErrors = [];
//     const currentAccountType = accountType?.value;
    
//     if (type === "seeker" && !currentAccountType) {
//       validationErrors.push({ 
//         code: 'account_type', 
//         message: t("validation.selectAccountType") 
//       });
//     }
    
//     const requiredFields = [
//       { name: 'first_name', value: inputValues.first_name },
//       { name: 'last_name', value: inputValues.last_name },
//       { name: 'email', value: inputValues.email },
//       { name: 'phone', value: inputValues.phone }
//     ];
    
//     const isCompany = (type === "provider") || (type === "seeker" && currentAccountType === "company");
//     if (isCompany) {
//       requiredFields.push({ name: 'social_reason', value: inputValues.social_reason });
//     }
    
//     for (const field of requiredFields) {
//       const errorMessage = validateField(
//         field.name, 
//         field.value || '', 
//         t, 
//         inputValues, 
//         type, 
//         currentAccountType
//       );
//       if (errorMessage) {
//         validationErrors.push({ code: field.name, message: errorMessage });
//       }
//     }
    
//     setErrors(validationErrors);
//     return validationErrors.length === 0;
//   };

//   const validateRegularRegistrationForm = () => {
//     const validationErrors = [];
//     const currentAccountType = accountType?.value;
    
//     if (type === "seeker" && !currentAccountType) {
//       validationErrors.push({ 
//         code: 'account_type', 
//         message: t("validation.selectAccountType") 
//       });
//     }
    
//     const requiredFields = [
//       { name: 'first_name', value: inputValues.first_name },
//       { name: 'last_name', value: inputValues.last_name },
//       { name: 'email', value: inputValues.email },
//       { name: 'phone', value: inputValues.phone },
//       { name: 'password', value: inputValues.password },
//       { name: 'password_confirmation', value: inputValues.password_confirmation }
//     ];
    
//     const isCompany = (type === "provider") || (type === "seeker" && currentAccountType === "company");
//     if (isCompany) {
//       requiredFields.push({ name: 'social_reason', value: inputValues.social_reason });
//     }
    
//     for (const field of requiredFields) {
//       const errorMessage = validateField(
//         field.name, 
//         field.value || '', 
//         t, 
//         inputValues, 
//         type, 
//         currentAccountType
//       );
//       if (errorMessage) {
//         validationErrors.push({ code: field.name, message: errorMessage });
//       }
//     }
    
//     setErrors(validationErrors);
//     return validationErrors.length === 0;
//   };

//   // ============================================================
//   // handleRegistrationSuccess - ONLY CALLED WHEN SIGNUP SUCCEEDS
//   // ============================================================
//  // ============================================================
// // handleRegistrationSuccess - ONLY CALLED WHEN SIGNUP SUCCEEDS
// // ============================================================
// const handleRegistrationSuccess = (shouldRedirectToSpace = false, spaceReturnUrl = null, registrationData = null) => {
//   // ============================================================
//   // ✅ TRACK SUCCESSFUL REGISTRATION (ONLY ON SUCCESS)
//   // ============================================================
//   const eventData = {
//     'event': 'validation-formulaire-inscription',
//     'event_category': 'Inscription',
//     'event_action': 'submit',
//     'event_label': googleRegistrationData ? 'Google Signup' : 'Email Signup',
//     'method': googleRegistrationData ? 'google' : 'email',
//     'user_type': type,
//     'account_type': accountType?.value || (type === "provider" ? "company" : "individual"),
//     'for_booking_form': forBookingForm,
//     'status': 'success',
//     'timestamp': new Date().toISOString()
//   };
  
//   // ✅ Add email hash (NO PII)
//   const email = inputValues.email || registrationData?.email;
//   if (email) {
//     eventData.email_hash = hashEmail(email);
//   }
  
//   // ✅ Push to dataLayer
//   window.dataLayer.push(eventData);
  
//   if (process.env.NODE_ENV === 'development') {
//     console.log('[SignupForm] ✅ Signup success tracked:', eventData);
//   }
  
//   // ============================================================
//   // CLOSE THE MODAL
//   // ============================================================
//   closeModal();
  
//   // ============================================================
//   // CHECK FOR BOOKING CONTEXT FROM signup_booking_context
//   // ============================================================
//   const bookingContext = sessionStorage.getItem('signup_booking_context');
//   let isBookingForm = false;
//   let returnUrlBooking = null;
  
//   if (bookingContext) {
//     try {
//       const context = JSON.parse(bookingContext);
//       if (context.forBookingForm) {
//         isBookingForm = true;
//         returnUrlBooking = context.returnUrl;
//       }
//       sessionStorage.removeItem('signup_booking_context');
//     } catch (e) {
//       console.error('Failed to parse booking context:', e);
//     }
//   }
  
//   // ============================================================
//   // CHECK FOR forBookingForm PROP FROM COMPONENT
//   // ============================================================
//   if (forBookingForm && returnUrl) {
//     isBookingForm = true;
//     returnUrlBooking = returnUrl;
//   }
  
//   // ============================================================
//   // CRITICAL FIX: Check for pending booking after Google OAuth
//   // ============================================================
//   const hasPendingBookingAfterOAuth = sessionStorage.getItem('has_pending_booking_after_oauth') === 'true';
//   const pendingBookingData = sessionStorage.getItem('pending_booking_data');
  
//   if (hasPendingBookingAfterOAuth && pendingBookingData) {
//     console.log('[SignupForm] 🔄 Google OAuth registration - has pending booking');
//     isBookingForm = true;
    
//     try {
//       const data = JSON.parse(pendingBookingData);
//       if (data.spaceId) {
//         returnUrlBooking = `/space/${data.spaceId}`;
//         // Keep the pending data so CompactBookingForm can process it
//         // Do NOT clear it here
//         console.log('[SignupForm] ✅ Pending booking preserved for:', returnUrlBooking);
//       }
//     } catch (e) {
//       console.error('[SignupForm] Failed to parse pending booking data:', e);
//     }
//   }
  
//   // ============================================================
//   // CHECK FOR has_pending_booking_after_oauth FROM AUTH ENDPOINT
//   // ============================================================
//   const hasPendingAfterOAuth = sessionStorage.getItem('has_pending_booking_after_oauth') === 'true';
//   if (hasPendingAfterOAuth) {
//     console.log('[SignupForm] 🔄 Has pending booking after OAuth');
//     isBookingForm = true;
    
//     // Try to get the space ID from booking_space_id
//     const bookingSpaceId = sessionStorage.getItem('booking_space_id');
//     if (bookingSpaceId) {
//       returnUrlBooking = `/space/${bookingSpaceId}`;
//       console.log('[SignupForm] ✅ Using booking_space_id for redirect:', returnUrlBooking);
//     }
    
//     // Do NOT clear has_pending_booking_after_oauth here - let CompactBookingForm clear it
//   }
  
//   // ============================================================
//   // CLEAR GOOGLE REGISTRATION DATA (BUT KEEP PENDING BOOKING)
//   // ============================================================
//   sessionStorage.removeItem('google_registration_data');
//   sessionStorage.removeItem('google_oauth_intent');
//   sessionStorage.removeItem('google_signup_type');
//   sessionStorage.removeItem('google_oauth_state');
  
//   // ============================================================
//   // IMPORTANT: DO NOT clear pending_booking_data if it's a booking flow
//   // ============================================================
//   if (!isBookingForm) {
//     sessionStorage.removeItem('pending_booking_data');
//     sessionStorage.removeItem('booking_space_id');
//     sessionStorage.removeItem('login_timestamp');
//     sessionStorage.removeItem('registration_timestamp');
//   } else {
//     // For booking flow, keep pending_booking_data but clear timestamps
//     sessionStorage.removeItem('login_timestamp');
//     sessionStorage.removeItem('registration_timestamp');
//     // Keep: pending_booking_data, booking_space_id, has_pending_booking_after_oauth
//   }
  
//   // ============================================================
//   // HANDLE BOOKING FORM FLOW
//   // ============================================================
//   if (isBookingForm) {
//     console.log('[SignupForm] ✅ Booking form detected, redirecting to:', returnUrlBooking || '/dashboard');
    
//     // Add a small delay to ensure everything is processed
//     setTimeout(() => {
//       if (onSuccess) {
//         onSuccess();
//       } else if (returnUrlBooking) {
//         navigate(returnUrlBooking, { replace: true });
//       } else {
//         // Fallback: try to get space ID from booking_space_id
//         const spaceId = sessionStorage.getItem('booking_space_id');
//         if (spaceId) {
//           navigate(`/space/${spaceId}`, { replace: true });
//         } else {
//           navigate('/dashboard', { replace: true });
//         }
//       }
//     }, 500);
//     return;
//   }
  
//   // ============================================================
//   // HANDLE REGULAR (NON-BOOKING) FLOW - SHOW SUCCESS MODAL
//   // ============================================================
//   openModal({
//     content: (
//       <div style={{ textAlign: 'center', padding: '20px' }}>
//         <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
//           <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#4caf50"/>
//         </svg>
//         <h3>{t("modal.register.successTitle")}</h3>
//         <p>{t("modal.register.successMessage")}</p>
//       </div>
//     ),
//     title: null,
//     type: "success",
//     autoClose: true,
//     closeDelay: 2000,
//   });
  
//   // ============================================================
//   // REDIRECT AFTER SUCCESS MODAL
//   // ============================================================
//   setTimeout(() => {
//     if (shouldRedirectToSpace && spaceReturnUrl) {
//       navigate(spaceReturnUrl, { replace: true });
//     } else if (onSuccess) {
//       onSuccess();
//     } else {
//       navigate('/dashboard', { replace: true });
//     }
//   }, 2000);
// };
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Only clear pending data for non-booking forms
//     if (!forBookingForm) {
//       clearPendingBookingData();
//     }

//     if (!cgu) {
//       setGeneralErrors([{ type: 'error', message: t("validation.acceptTerms") }]);
//       return;
//     }

//     // ADDED: Validate CAPTCHA token exists - COMMENTED OUT
//     // if (!captchaToken) {
//     //   setGeneralErrors((prev) => {
//     //     const filtered = prev.filter(err => err.type !== 'captcha');
//     //     return [...filtered, { 
//     //       type: 'error', 
//     //       message: t("modal.register.captcha.required") 
//     //     }];
//     //   });
//     //   // Reset the widget to prompt user to complete it
//     //   if (turnstileRef.current) {
//     //     turnstileRef.current.reset();
//     //   }
//     //   return;
//     // }

//     // Handle Google registration
//     if (googleRegistrationData) {
//       const allFields = ['first_name', 'last_name', 'email', 'phone'];
//       if (type === "provider" || (type === "seeker" && accountType?.value === "company")) {
//         allFields.push('social_reason');
//       }
//       const touched = {};
//       allFields.forEach(field => { touched[field] = true; });
//       setTouchedFields(touched);
      
//       const isValid = validateGoogleRegistrationForm();
//       if (!isValid) {
//         const firstError = errors[0];
//         if (firstError) {
//           const element = document.querySelector(`[name="${firstError.code}"]`);
//           if (element) {
//             element.scrollIntoView({ behavior: 'smooth', block: 'center' });
//           }
//         }
//         return;
//       }
      
//       setLoading(true);
//       try {
//         let userTypeValue, statusValue;
        
//         if (type === "seeker") {
//           userTypeValue = "seeker";
//           statusValue = accountType?.value === "individual" ? "individual" : "company";
//         } else {
//           userTypeValue = "provider";
//           statusValue = "company";
//         }
        
//         const finalLang = getCurrentLanguage();
//         const googleId = googleRegistrationData.userData.google || googleRegistrationData.userData.google_id;
//         const phoneValue = inputValues.phone || '';
        
//         if (!googleId) {
//           throw new Error("Missing Google ID");
//         }
        
//         // CHANGED: Include captcha_token in the registration payload - COMMENTED OUT captcha_token
//         const result = await dispatch(completeSocialRegistration({
//           provider: 'google',
//           userData: {
//             email: inputValues.email || googleRegistrationData.userData.email,
//             first_name: inputValues.first_name || googleRegistrationData.userData.first_name,
//             last_name: inputValues.last_name || googleRegistrationData.userData.last_name,
//             google: googleId,
//             phone: phoneValue,
//             social_reason: inputValues.social_reason || '',
//             domain: window.location.hostname.split(".").pop(),
//           },
//           userType: userTypeValue,
//           status: statusValue,
//           language: finalLang,
//           forBookingForm: forBookingForm,
//           spaceId: spaceId,
//           // captcha_token: captchaToken // ADDED: Include CAPTCHA token - COMMENTED OUT
//         })).unwrap();
        
//         console.log("[SignupForm] Registration result:", result);
        
//         handleRegistrationSuccess(false, null, {
//           email: inputValues.email || googleRegistrationData.userData.email
//         });
        
//       } catch (error) {
//         console.error("[SignupForm] Google registration error:", error);
        
//         // ADDED: Check for CAPTCHA validation error from backend - COMMENTED OUT
//         // if (error?.captcha_token || error?.captcha) {
//         //   setGeneralErrors([{ 
//         //     type: 'error', 
//         //     message: t("modal.register.captcha.invalid") 
//         //   }]);
//         //   resetCaptcha();
//         //   setLoading(false);
//         //   return;
//         // }
        
//         if (Array.isArray(error)) {
//           // Check if any error is CAPTCHA-related - COMMENTED OUT
//           // const hasCaptchaError = error.some(err => err.code === 'captcha_token');
//           // if (hasCaptchaError) {
//           //   setGeneralErrors([{ 
//           //     type: 'error', 
//           //     message: t("modal.register.captcha.invalid") 
//           //   }]);
//           //   resetCaptcha();
//           // } else {
//           //   setGeneralErrors(error.map(err => ({ type: 'error', message: err.message })));
//           // }
//           setGeneralErrors(error.map(err => ({ type: 'error', message: err.message })));
//         } else if (error?.message) {
//           setGeneralErrors([{ type: 'error', message: error.message }]);
//         } else {
//           setGeneralErrors([{ type: 'error', message: t("modal.register.registrationFailed") }]);
//         }
//         setLoading(false);
//       }
//       return;
//     }

//     // Regular email/password registration
//     const allFields = ['first_name', 'last_name', 'email', 'phone', 'password', 'password_confirmation'];
//     if (type === "provider" || (type === "seeker" && accountType?.value === "company")) {
//       allFields.push('social_reason');
//     }
//     const touched = {};
//     allFields.forEach(field => { touched[field] = true; });
//     setTouchedFields(touched);
    
//     const isValid = validateRegularRegistrationForm();
//     if (!isValid) {
//       const firstError = errors[0];
//       if (firstError) {
//         const element = document.querySelector(`[name="${firstError.code}"]`);
//         if (element) {
//           element.scrollIntoView({ behavior: 'smooth', block: 'center' });
//         }
//       }
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const finalLang = getCurrentLanguage();
      
//       // CHANGED: Include captcha_token in the registration payload - COMMENTED OUT captcha_token
//       const resultAction = await dispatch(register({
//         user: {
//           ...inputValues,
//           cgu,
//           newsletter,
//           type: type,
//           status: type === "provider" ? "company" : (accountType?.value === "individual" ? "individual" : "company"),
//           lang: finalLang,
//           mobile_app: false,
//           domain: window.location.hostname.split(".").pop(),
//           // captcha_token: captchaToken // ADDED: Include CAPTCHA token - COMMENTED OUT
//         },
//         forBookingForm: forBookingForm,
//         spaceId: spaceId
//       }));
      
//       if (register.fulfilled.match(resultAction)) {
//         handleRegistrationSuccess(false, null, {
//           email: inputValues.email
//         });
//       } else {
//         // ADDED: Check for CAPTCHA validation error from backend - COMMENTED OUT
//         // const payload = resultAction.payload;
//         // if (payload && Array.isArray(payload) && payload.some(err => err.code === 'captcha_token')) {
//         //   setGeneralErrors([{ 
//         //     type: 'error', 
//         //     message: t("modal.register.captcha.invalid") 
//         //   }]);
//         //   resetCaptcha();
//         // } else {
//         //   setGeneralErrors(payload || [{ type: 'error', message: t("modal.register.registrationFailed") }]);
//         // }
//         setGeneralErrors(resultAction.payload || [{ type: 'error', message: t("modal.register.registrationFailed") }]);
//       }
//     } catch (error) {
//       // ADDED: Check for CAPTCHA validation error from backend - COMMENTED OUT
//       // if (error?.captcha_token || error?.captcha) {
//       //   setGeneralErrors([{ 
//       //     type: 'error', 
//       //     message: t("modal.register.captcha.invalid") 
//       //   }]);
//       //   resetCaptcha();
//       //   setLoading(false);
//       //   return;
//       // }
      
//       setGeneralErrors([{ type: 'error', message: error.message || t("modal.register.registrationFailed") }]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderMessages = () => {
//     if (!generalErrors.length) return null;
    
//     return (
//       <div className={styles.messageContainer}>
//         {generalErrors.map((err, index) => (
//           <div key={index} className={`${styles.message} ${styles[err.type || 'error']}`}>
//             {err.message}
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className={styles.signupForm}>
//       {!googleRegistrationData && (
//         <>
//           {forBookingForm && (
//             <div className={styles.bookingFormHeader}>
//               <p className={styles.bookingFormTitle}>
//                 {t("modal.register.bookingFormTitle")}
//               </p>
//             </div>
//           )}
          
//           <div className={styles.googleSignupSection}>
//             {forBookingForm && (
//               <p className={styles.googleSignupLabel}>
//                 {t("modal.register.signupGoogleLabel")}
//               </p>
//             )}
//             <div className={styles.googleSignupContainer}>
//               <button 
//                 onClick={handleGoogleSignupClick} 
//                 className={styles.googleSignupButton} 
//                 disabled={loading} 
//                 type="button"
//               >
//                 <svg width="18" height="18" viewBox="0 0 48 48">
//                   <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
//                   <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
//                   <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
//                   <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
//                 </svg>
//                 <span>{t("modal.register.signupGoogle")}</span>
//               </button>
//             </div>
//           </div>
          
//           <div className={styles.signupModuleSeparationBox}>
//             <hr />
//             <p>{t("modal.register.or")}</p>
//             <hr />
//           </div>
          
//           {forBookingForm && (
//             <div className={styles.emailSignupLabel}>
//               <p className={styles.emailSignupText}>
//                 {t("modal.register.emailSignupLabel")}
//               </p>
//             </div>
//           )}
//         </>
//       )}

//       {googleRegistrationData && (
//         <div className={styles.googleRegistrationInfo}>
//           <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
//             <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#1a73e8"/>
//           </svg>
//           <p>{t("modal.register.googlePrefilled")}</p>
//         </div>
//       )}

//       <SignUpFormInputs
//         signupInputValues={inputValues}
//         setSignupInputValues={handleInputChange}
//         status={accountType?.value || "company"}
//         errors={errors}
//         setErrors={setErrors}
//         onInputBlur={handleInputBlur}
//         accountType={accountType}
//         setAccountType={setAccountType}
//         userType={type}
//         googlePrefilled={!!googleRegistrationData}
//         hidePasswordFields={!!googleRegistrationData}
//       />

//       <Checkbox 
//         label={
//           <p>
//             {t("modal.register.acceptTerms")}{" "}
//             <a href="/static/politique-confidentialite" target="_blank" rel="noopener noreferrer">
//               {t("modal.register.Terms")}
//             </a>
//           </p>
//         } 
//         onChange={() => setCgu(!cgu)} 
//         checked={cgu} 
//       />
      
//       <Checkbox 
//         label={t("modal.register.acceptNewsletter")} 
//         checked={newsletter} 
//         onChange={() => setNewsletter(!newsletter)} 
//       />

//       {/* ADDED: Turnstile CAPTCHA Widget - COMMENTED OUT */}
//       {/* <div className={styles.captchaContainer}>
//         <Turnstile
//           ref={turnstileRef}
//           siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
//           onSuccess={handleCaptchaSuccess}
//           onError={handleCaptchaError}
//           onExpire={handleCaptchaExpire}
//           options={{
//             theme: 'light',
//             size: 'normal',
//             language: getCurrentLanguage()
//           }}
//         />
//         {captchaError && (
//           <p className={styles.captchaError}>
//             {t("modal.register.captcha.error")}
//           </p>
//         )}
//       </div> */}

//       {renderMessages()}

//       <button 
//         type="submit" 
//         onClick={handleSubmit} 
//         className={`${styles.btn} ${styles.signup}`} 
//         // disabled={loading || !captchaToken}
//         disabled={loading}
//       >
//         {t("modal.register.register")}
//       </button>

//       {!googleRegistrationData && (
//         <div className={styles.loginLink}>
//           <p>
//             {t("modal.register.haveAccount")}{" "}
//             <a onClick={() => openModal({ content: <Login forBookingForm={forBookingForm} spaceId={spaceId} returnUrl={returnUrl} />, title: t("modal.login.title") })}>
//               {t("modal.register.login")}
//             </a>
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SignupForm;


// SignupForm.js - Complete with registration event tracking, booking form support, and Turnstile CAPTCHA
import Login from "modals/Login";
import { useDispatch } from "react-redux";
import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router";
import { register, completeSocialRegistration } from "store/auth/thunks";
import { Checkbox } from "reusableComponents";
import { useTranslation } from "react-i18next";
import { useLanguage, useModal } from "context";
import { useConsent } from "context/ConsentContext";
import SignUpFormInputs from "./SignUpFormInputs";
import { validateField } from "helpers/validation";
import { gtm } from "GTM";
import styles from "./styles.module.scss";
import i18next from "i18next";
// ADDED: Import Turnstile component
import { Turnstile } from "@marsidev/react-turnstile";

// Helper: Get or create session ID (stored in sessionStorage only)
const getOrCreateSessionId = () => {
  let sessionId = sessionStorage.getItem('gtm_functional_session_id');
  if (!sessionId) {
    sessionId = 'func_sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    sessionStorage.setItem('gtm_functional_session_id', sessionId);
  }
  return sessionId;
};

// Helper: Hash email for security tracking without storing PII
const hashEmail = (email) => {
  if (!email) return null;
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    const char = email.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(16);
};

const getCurrentLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  
  const hostname = window.location.hostname;
  
  // Domain-based language detection
  if (hostname.includes('.fr')) return 'fr';
  if (hostname.includes('.es')) return 'es';
  if (hostname.includes('.be')) return 'fr';
  if (hostname.includes('.uk')) return 'en';
  if (hostname.includes('.com')) return 'en';
  
  // Fallback to i18next
  if (i18next.language) {
    if (i18next.language === 'uk') return 'en';
    return i18next.language === 'be' ? 'fr' : i18next.language;
  }
  
  return 'en';
};

const SignupForm = ({ type = "seeker", forBookingForm = false, spaceId = null, returnUrl = null, onSuccess = null }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [t] = useTranslation("global");
  const { openModal, closeModal } = useModal();
  const { hasConsent } = useConsent();
  const [cgu, setCgu] = useState(false);
  const [accountType, setAccountType] = useState(() => {
    if (type === "provider") {
      return { label: t("modal.register.businessAccount"), value: "company" };
    }
    return null;
  });
  const [newsletter, setNewsletter] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [errors, setErrors] = useState([]);
  const [generalErrors, setGeneralErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [touchedFields, setTouchedFields] = useState({});
  const [googleRegistrationData, setGoogleRegistrationData] = useState(null);
  
  // ADDED: Turnstile state
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState(false);
  const turnstileRef = useRef(null);

  const getRedirectUri = useCallback(() => {
    if (typeof window === 'undefined') return '';
    return `${window.location.origin}/auth/auth-endpoint`;
  }, []);

  // Helper to clear any existing pending booking data - ONLY for non-booking forms
  const clearPendingBookingData = useCallback(() => {
    if (!forBookingForm) {
      sessionStorage.removeItem('pending_booking_data');
      sessionStorage.removeItem('google_oauth_state');
      sessionStorage.removeItem('google_registration_data');
      sessionStorage.removeItem('signup_booking_context');
      sessionStorage.removeItem('just_registered_for_booking');
      sessionStorage.removeItem('booking_space_id');
      console.log('[SignupForm] Cleared pending booking data (non-booking form)');
    } else {
      console.log('[SignupForm] Preserving pending booking data for booking form');
    }
  }, [forBookingForm]);

  // Store booking form context for Google OAuth redirect
  useEffect(() => {
    if (forBookingForm && spaceId) {
      if (!forBookingForm) {
        clearPendingBookingData();
      }
      
      sessionStorage.setItem('signup_booking_context', JSON.stringify({
        spaceId,
        returnUrl: returnUrl || `/space/${spaceId}`,
        timestamp: Date.now(),
        forBookingForm: true
      }));
    }
  }, [forBookingForm, spaceId, returnUrl, clearPendingBookingData]);

  // Handle Google OAuth callback for signup
  useEffect(() => {
    const storedData = sessionStorage.getItem('google_registration_data');
    const code = new URLSearchParams(window.location.search).get('code');
    
    if (code && !storedData && !googleRegistrationData) {
      const handleGoogleSignupCallback = async () => {
        setLoading(true);
        try {
          const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
          const redirectUri = getRedirectUri();
          
          const tokenResponse = await fetch('https://oauth2.googleapis.com/token', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
              code: code,
              client_id: clientId,
              client_secret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
              redirect_uri: redirectUri,
              grant_type: 'authorization_code',
            }),
          });
          
          const tokenData = await tokenResponse.json();
          
          if (tokenData.access_token) {
            const userInfoResponse = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
              headers: {
                Authorization: `Bearer ${tokenData.access_token}`,
              },
            });
            
            const userData = await userInfoResponse.json();
            
            sessionStorage.setItem('google_registration_data', JSON.stringify({
              userData: {
                email: userData.email,
                first_name: userData.given_name,
                last_name: userData.family_name,
                google_id: userData.id,
                google: userData.id
              },
              provider: 'google'
            }));
            
            window.history.replaceState({}, document.title, window.location.pathname);
            
            setGoogleRegistrationData({
              userData: {
                email: userData.email,
                first_name: userData.given_name,
                last_name: userData.family_name,
                google_id: userData.id,
                google: userData.id
              },
              provider: 'google'
            });
            
            setInputValues({
              email: userData.email || '',
              first_name: userData.given_name || '',
              last_name: userData.family_name || '',
            });
            
            const firstName = userData.given_name || '';
            const welcomeMessage = firstName 
              ? t("modal.register.welcomeGoogleWithName", { name: firstName })
              : t("modal.register.welcomeGoogle");
            
            setGeneralErrors([{ 
              type: 'success',
              message: welcomeMessage
            }]);
          }
        } catch (error) {
          console.error('Google signup callback error:', error);
          setGeneralErrors([{ type: 'error', message: t("modal.register.googleSignupError") }]);
        } finally {
          setLoading(false);
        }
      };
      
      handleGoogleSignupCallback();
    } else if (storedData && !googleRegistrationData) {
      try {
        const data = JSON.parse(storedData);
        console.log('[SignupForm] Google registration data found:', data);
        
        const userData = data.userData;
        const googleId = userData.google || userData.google_id || userData.sub;
        
        if (!googleId) {
          console.error('[SignupForm] No Google ID found');
          sessionStorage.removeItem('google_registration_data');
          return;
        }
        
        setGoogleRegistrationData({
          ...data,
          userData: {
            ...userData,
            google_id: googleId,
            google: googleId
          }
        });
        
        setInputValues({
          email: userData.email || '',
          first_name: userData.first_name || '',
          last_name: userData.last_name || '',
        });
        
        const firstName = userData.first_name || '';
        const welcomeMessage = firstName 
          ? t("modal.register.welcomeGoogleWithName", { name: firstName })
          : t("modal.register.welcomeGoogle");
        
        setGeneralErrors([{ 
          type: 'success',
          message: welcomeMessage
        }]);
        
      } catch (e) {
        console.error('[SignupForm] Error parsing Google data:', e);
        sessionStorage.removeItem('google_registration_data');
      }
    }
  }, [getRedirectUri, t]);

  const handleGoogleSignupClick = () => {
    if (loading) return;
    
    if (!forBookingForm) {
      clearPendingBookingData();
    }
    
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = getRedirectUri();
    
    if (!clientId) {
      setGeneralErrors([{ type: 'error', message: t("modal.register.googleConfigError") }]);
      return;
    }

    sessionStorage.setItem('google_oauth_intent', 'signup');
    sessionStorage.setItem('google_signup_type', type);
    
    if (forBookingForm && spaceId) {
      sessionStorage.setItem('signup_booking_context', JSON.stringify({
        spaceId,
        returnUrl: returnUrl || `/space/${spaceId}`,
        timestamp: Date.now(),
        forBookingForm: true
      }));
    }
    
    const state = JSON.stringify({
      token: 'google_oauth_' + Math.random().toString(36).substring(7),
      timestamp: Date.now(),
      intent: 'signup',
      userType: type,
      forBookingForm: forBookingForm,
      spaceId: spaceId,
      returnUrl: returnUrl
    });
    
    sessionStorage.setItem('google_oauth_state', state);

    const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
    authUrl.searchParams.append('client_id', clientId);
    authUrl.searchParams.append('redirect_uri', redirectUri);
    authUrl.searchParams.append('response_type', 'code');
    authUrl.searchParams.append('scope', 'email profile openid');
    authUrl.searchParams.append('access_type', 'online');
    authUrl.searchParams.append('prompt', 'consent');
    authUrl.searchParams.append('state', state);

    window.location.href = authUrl.toString();
  };

  const handleInputChange = useCallback((name, value) => {
    setInputValues((prev) => ({ ...prev, [name]: value }));
    
    setErrors((prevErrors) => prevErrors.filter(err => err.code !== name));
    
    if (touchedFields[name]) {
      const errorMessage = validateField(
        name, 
        value, 
        t, 
        { ...inputValues, [name]: value }, 
        type, 
        accountType?.value
      );
      if (errorMessage) {
        setErrors((prevErrors) => {
          const existing = prevErrors.find(err => err.code === name);
          if (existing) {
            return prevErrors.map(err => err.code === name ? { ...err, message: errorMessage } : err);
          }
          return [...prevErrors, { code: name, message: errorMessage }];
        });
      }
    }
  }, [touchedFields, inputValues, t, type, accountType]);

  const handleInputBlur = useCallback((name, value) => {
    setTouchedFields((prev) => ({ ...prev, [name]: true }));
    const errorMessage = validateField(name, value, t, inputValues, type, accountType?.value);
    
    if (errorMessage) {
      setErrors((prevErrors) => {
        const existing = prevErrors.find(err => err.code === name);
        if (existing) {
          return prevErrors.map(err => err.code === name ? { ...err, message: errorMessage } : err);
        }
        return [...prevErrors, { code: name, message: errorMessage }];
      });
    } else {
      setErrors((prevErrors) => prevErrors.filter(err => err.code !== name));
    }
  }, [inputValues, t, type, accountType]);

  const handleAccountTypeChange = useCallback((option) => {
  setAccountType(option);
  // Clear account_type error when user selects a type
  setErrors((prevErrors) => prevErrors.filter(err => err.code !== 'account_type'));
}, []);

  // ADDED: Turnstile callback handlers
  const handleCaptchaSuccess = useCallback((token) => {
    console.log('[SignupForm] Turnstile token received');
    setCaptchaToken(token);
    setCaptchaError(false);
  }, []);

  const handleCaptchaError = useCallback(() => {
    console.error('[SignupForm] Turnstile error');
    setCaptchaError(true);
    setCaptchaToken(null);
  }, []);

  const handleCaptchaExpire = useCallback(() => {
    console.log('[SignupForm] Turnstile token expired');
    setCaptchaToken(null);
    // Show a message to the user that they need to complete the CAPTCHA again
    setGeneralErrors((prev) => {
      const filtered = prev.filter(err => err.type !== 'captcha');
      return [...filtered, { 
        type: 'error', 
        message: t("modal.register.captcha.expired") 
      }];
    });
  }, [t]);

  // ADDED: Reset captcha on 422 error
  const resetCaptcha = useCallback(() => {
    if (turnstileRef.current) {
      // Reset the Turnstile widget
      turnstileRef.current.reset();
    }
    setCaptchaToken(null);
    setCaptchaError(false);
  }, []);

  const validateGoogleRegistrationForm = () => {
    const validationErrors = [];
    const currentAccountType = accountType?.value;
    
    if (type === "seeker" && !currentAccountType) {
      validationErrors.push({ 
        code: 'account_type', 
        message: t("validation.selectAccountType") 
      });
    }
    
    const requiredFields = [
      { name: 'first_name', value: inputValues.first_name },
      { name: 'last_name', value: inputValues.last_name },
      { name: 'email', value: inputValues.email },
      { name: 'phone', value: inputValues.phone }
    ];
    
    const isCompany = (type === "provider") || (type === "seeker" && currentAccountType === "company");
    if (isCompany) {
      requiredFields.push({ name: 'social_reason', value: inputValues.social_reason });
    }
    
    for (const field of requiredFields) {
      const errorMessage = validateField(
        field.name, 
        field.value || '', 
        t, 
        inputValues, 
        type, 
        currentAccountType
      );
      if (errorMessage) {
        validationErrors.push({ code: field.name, message: errorMessage });
      }
    }
    
    setErrors(validationErrors);
    return validationErrors.length === 0;
  };

  const validateRegularRegistrationForm = () => {
    const validationErrors = [];
    const currentAccountType = accountType?.value;
    
    if (type === "seeker" && !currentAccountType) {
      validationErrors.push({ 
        code: 'account_type', 
        message: t("validation.selectAccountType") 
      });
    }
    
    const requiredFields = [
      { name: 'first_name', value: inputValues.first_name },
      { name: 'last_name', value: inputValues.last_name },
      { name: 'email', value: inputValues.email },
      { name: 'phone', value: inputValues.phone },
      { name: 'password', value: inputValues.password },
      { name: 'password_confirmation', value: inputValues.password_confirmation }
    ];
    
    const isCompany = (type === "provider") || (type === "seeker" && currentAccountType === "company");
    if (isCompany) {
      requiredFields.push({ name: 'social_reason', value: inputValues.social_reason });
    }
    
    for (const field of requiredFields) {
      const errorMessage = validateField(
        field.name, 
        field.value || '', 
        t, 
        inputValues, 
        type, 
        currentAccountType
      );
      if (errorMessage) {
        validationErrors.push({ code: field.name, message: errorMessage });
      }
    }
    
    setErrors(validationErrors);
    return validationErrors.length === 0;
  };

  // ============================================================
  // handleRegistrationSuccess - ONLY CALLED WHEN SIGNUP SUCCEEDS
  // ============================================================
 // ============================================================
// handleRegistrationSuccess - ONLY CALLED WHEN SIGNUP SUCCEEDS
// ============================================================
const handleRegistrationSuccess = (shouldRedirectToSpace = false, spaceReturnUrl = null, registrationData = null) => {
  // ============================================================
  // ✅ TRACK SUCCESSFUL REGISTRATION (ONLY ON SUCCESS)
  // ============================================================
  const eventData = {
    'event': 'validation-formulaire-inscription',
    'event_category': 'Inscription',
    'event_action': 'submit',
    'event_label': googleRegistrationData ? 'Google Signup' : 'Email Signup',
    'method': googleRegistrationData ? 'google' : 'email',
    'user_type': type,
    'account_type': accountType?.value || (type === "provider" ? "company" : "individual"),
    'for_booking_form': forBookingForm,
    'status': 'success',
    'timestamp': new Date().toISOString()
  };
  
  // ✅ Add email hash (NO PII)
  const email = inputValues.email || registrationData?.email;
  if (email) {
    eventData.email_hash = hashEmail(email);
  }
  
  // ✅ Push to dataLayer
  window.dataLayer.push(eventData);
  
  if (process.env.NODE_ENV === 'development') {
    console.log('[SignupForm] ✅ Signup success tracked:', eventData);
  }
  
  // ============================================================
  // CLOSE THE MODAL
  // ============================================================
  closeModal();
  
  // ============================================================
  // CHECK FOR BOOKING CONTEXT FROM signup_booking_context
  // ============================================================
  const bookingContext = sessionStorage.getItem('signup_booking_context');
  let isBookingForm = false;
  let returnUrlBooking = null;
  
  if (bookingContext) {
    try {
      const context = JSON.parse(bookingContext);
      if (context.forBookingForm) {
        isBookingForm = true;
        returnUrlBooking = context.returnUrl;
      }
      sessionStorage.removeItem('signup_booking_context');
    } catch (e) {
      console.error('Failed to parse booking context:', e);
    }
  }
  
  // ============================================================
  // CHECK FOR forBookingForm PROP FROM COMPONENT
  // ============================================================
  if (forBookingForm && returnUrl) {
    isBookingForm = true;
    returnUrlBooking = returnUrl;
  }
  
  // ============================================================
  // CRITICAL FIX: Check for pending booking after Google OAuth
  // ============================================================
  const hasPendingBookingAfterOAuth = sessionStorage.getItem('has_pending_booking_after_oauth') === 'true';
  const pendingBookingData = sessionStorage.getItem('pending_booking_data');
  
  if (hasPendingBookingAfterOAuth && pendingBookingData) {
    console.log('[SignupForm] 🔄 Google OAuth registration - has pending booking');
    isBookingForm = true;
    
    try {
      const data = JSON.parse(pendingBookingData);
      if (data.spaceId) {
        returnUrlBooking = `/space/${data.spaceId}`;
        // Keep the pending data so CompactBookingForm can process it
        // Do NOT clear it here
        console.log('[SignupForm] ✅ Pending booking preserved for:', returnUrlBooking);
      }
    } catch (e) {
      console.error('[SignupForm] Failed to parse pending booking data:', e);
    }
  }
  
  // ============================================================
  // CHECK FOR has_pending_booking_after_oauth FROM AUTH ENDPOINT
  // ============================================================
  const hasPendingAfterOAuth = sessionStorage.getItem('has_pending_booking_after_oauth') === 'true';
  if (hasPendingAfterOAuth) {
    console.log('[SignupForm] 🔄 Has pending booking after OAuth');
    isBookingForm = true;
    
    // Try to get the space ID from booking_space_id
    const bookingSpaceId = sessionStorage.getItem('booking_space_id');
    if (bookingSpaceId) {
      returnUrlBooking = `/space/${bookingSpaceId}`;
      console.log('[SignupForm] ✅ Using booking_space_id for redirect:', returnUrlBooking);
    }
    
    // Do NOT clear has_pending_booking_after_oauth here - let CompactBookingForm clear it
  }
  
  // ============================================================
  // CLEAR GOOGLE REGISTRATION DATA (BUT KEEP PENDING BOOKING)
  // ============================================================
  sessionStorage.removeItem('google_registration_data');
  sessionStorage.removeItem('google_oauth_intent');
  sessionStorage.removeItem('google_signup_type');
  sessionStorage.removeItem('google_oauth_state');
  
  // ============================================================
  // IMPORTANT: DO NOT clear pending_booking_data if it's a booking flow
  // ============================================================
  if (!isBookingForm) {
    sessionStorage.removeItem('pending_booking_data');
    sessionStorage.removeItem('booking_space_id');
    sessionStorage.removeItem('login_timestamp');
    sessionStorage.removeItem('registration_timestamp');
  } else {
    // For booking flow, keep pending_booking_data but clear timestamps
    sessionStorage.removeItem('login_timestamp');
    sessionStorage.removeItem('registration_timestamp');
    // Keep: pending_booking_data, booking_space_id, has_pending_booking_after_oauth
  }
  
  // ============================================================
  // HANDLE BOOKING FORM FLOW
  // ============================================================
  if (isBookingForm) {
    console.log('[SignupForm] ✅ Booking form detected, redirecting to:', returnUrlBooking || '/dashboard');
    
    // Add a small delay to ensure everything is processed
    setTimeout(() => {
      if (onSuccess) {
        onSuccess();
      } else if (returnUrlBooking) {
        navigate(returnUrlBooking, { replace: true });
      } else {
        // Fallback: try to get space ID from booking_space_id
        const spaceId = sessionStorage.getItem('booking_space_id');
        if (spaceId) {
          navigate(`/space/${spaceId}`, { replace: true });
        } else {
          navigate('/dashboard', { replace: true });
        }
      }
    }, 500);
    return;
  }
  
  // ============================================================
  // HANDLE REGULAR (NON-BOOKING) FLOW - SHOW SUCCESS MODAL
  // ============================================================
  openModal({
    content: (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#4caf50"/>
        </svg>
        <h3>{t("modal.register.successTitle")}</h3>
        <p>{t("modal.register.successMessage")}</p>
      </div>
    ),
    title: null,
    type: "success",
    autoClose: true,
    closeDelay: 2000,
  });
  
  // ============================================================
  // REDIRECT AFTER SUCCESS MODAL
  // ============================================================
  setTimeout(() => {
    if (shouldRedirectToSpace && spaceReturnUrl) {
      navigate(spaceReturnUrl, { replace: true });
    } else if (onSuccess) {
      onSuccess();
    } else {
      navigate('/dashboard', { replace: true });
    }
  }, 2000);
};
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Only clear pending data for non-booking forms
    if (!forBookingForm) {
      clearPendingBookingData();
    }

    if (!cgu) {
      setGeneralErrors([{ type: 'error', message: t("validation.acceptTerms") }]);
      return;
    }

    // ADDED: Validate CAPTCHA token exists
    if (!captchaToken) {
      setGeneralErrors((prev) => {
        const filtered = prev.filter(err => err.type !== 'captcha');
        return [...filtered, { 
          type: 'error', 
          message: t("modal.register.captcha.required") 
        }];
      });
      // Reset the widget to prompt user to complete it
      if (turnstileRef.current) {
        turnstileRef.current.reset();
      }
      return;
    }

    // Handle Google registration
    if (googleRegistrationData) {
      const allFields = ['first_name', 'last_name', 'email', 'phone'];
      if (type === "provider" || (type === "seeker" && accountType?.value === "company")) {
        allFields.push('social_reason');
      }
      const touched = {};
      allFields.forEach(field => { touched[field] = true; });
      setTouchedFields(touched);
      
      const isValid = validateGoogleRegistrationForm();
      if (!isValid) {
        const firstError = errors[0];
        if (firstError) {
          const element = document.querySelector(`[name="${firstError.code}"]`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
        return;
      }
      
      setLoading(true);
      try {
        let userTypeValue, statusValue;
        
        if (type === "seeker") {
          userTypeValue = "seeker";
          statusValue = accountType?.value === "individual" ? "individual" : "company";
        } else {
          userTypeValue = "provider";
          statusValue = "company";
        }
        
        const finalLang = getCurrentLanguage();
        const googleId = googleRegistrationData.userData.google || googleRegistrationData.userData.google_id;
        const phoneValue = inputValues.phone || '';
        
        if (!googleId) {
          throw new Error("Missing Google ID");
        }
        
        // CHANGED: Include captcha_token in the registration payload
        const result = await dispatch(completeSocialRegistration({
          provider: 'google',
          userData: {
            email: inputValues.email || googleRegistrationData.userData.email,
            first_name: inputValues.first_name || googleRegistrationData.userData.first_name,
            last_name: inputValues.last_name || googleRegistrationData.userData.last_name,
            google: googleId,
            phone: phoneValue,
            social_reason: inputValues.social_reason || '',
            domain: window.location.hostname.split(".").pop(),
          },
          userType: userTypeValue,
          status: statusValue,
          language: finalLang,
          forBookingForm: forBookingForm,
          spaceId: spaceId,
          captcha_token: captchaToken // ADDED: Include CAPTCHA token
        })).unwrap();
        
        console.log("[SignupForm] Registration result:", result);
        
        handleRegistrationSuccess(false, null, {
          email: inputValues.email || googleRegistrationData.userData.email
        });
        
      } catch (error) {
        console.error("[SignupForm] Google registration error:", error);
        
        // ADDED: Check for CAPTCHA validation error from backend
        if (error?.captcha_token || error?.captcha) {
          setGeneralErrors([{ 
            type: 'error', 
            message: t("modal.register.captcha.invalid") 
          }]);
          resetCaptcha();
          setLoading(false);
          return;
        }
        
        if (Array.isArray(error)) {
          // Check if any error is CAPTCHA-related
          const hasCaptchaError = error.some(err => err.code === 'captcha_token');
          if (hasCaptchaError) {
            setGeneralErrors([{ 
              type: 'error', 
              message: t("modal.register.captcha.invalid") 
            }]);
            resetCaptcha();
          } else {
            setGeneralErrors(error.map(err => ({ type: 'error', message: err.message })));
          }
        } else if (error?.message) {
          setGeneralErrors([{ type: 'error', message: error.message }]);
        } else {
          setGeneralErrors([{ type: 'error', message: t("modal.register.registrationFailed") }]);
        }
        setLoading(false);
      }
      return;
    }

    // Regular email/password registration
    const allFields = ['first_name', 'last_name', 'email', 'phone', 'password', 'password_confirmation'];
    if (type === "provider" || (type === "seeker" && accountType?.value === "company")) {
      allFields.push('social_reason');
    }
    const touched = {};
    allFields.forEach(field => { touched[field] = true; });
    setTouchedFields(touched);
    
    const isValid = validateRegularRegistrationForm();
    if (!isValid) {
      const firstError = errors[0];
      if (firstError) {
        const element = document.querySelector(`[name="${firstError.code}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      return;
    }
    
    setLoading(true);
    try {
      const finalLang = getCurrentLanguage();
      
      // CHANGED: Include captcha_token in the registration payload
      const resultAction = await dispatch(register({
        user: {
          ...inputValues,
          cgu,
          newsletter,
          type: type,
          status: type === "provider" ? "company" : (accountType?.value === "individual" ? "individual" : "company"),
          lang: finalLang,
          mobile_app: false,
          domain: window.location.hostname.split(".").pop(),
          captcha_token: captchaToken // ADDED: Include CAPTCHA token
        },
        forBookingForm: forBookingForm,
        spaceId: spaceId
      }));
      
      if (register.fulfilled.match(resultAction)) {
        handleRegistrationSuccess(false, null, {
          email: inputValues.email
        });
      } else {
        // ADDED: Check for CAPTCHA validation error from backend
        const payload = resultAction.payload;
        if (payload && Array.isArray(payload) && payload.some(err => err.code === 'captcha_token')) {
          setGeneralErrors([{ 
            type: 'error', 
            message: t("modal.register.captcha.invalid") 
          }]);
          resetCaptcha();
        } else {
          setGeneralErrors(payload || [{ type: 'error', message: t("modal.register.registrationFailed") }]);
        }
      }
    } catch (error) {
      // ADDED: Check for CAPTCHA validation error from backend
      if (error?.captcha_token || error?.captcha) {
        setGeneralErrors([{ 
          type: 'error', 
          message: t("modal.register.captcha.invalid") 
        }]);
        resetCaptcha();
        setLoading(false);
        return;
      }
      
      setGeneralErrors([{ type: 'error', message: error.message || t("modal.register.registrationFailed") }]);
    } finally {
      setLoading(false);
    }
  };

  const renderMessages = () => {
    if (!generalErrors.length) return null;
    
    return (
      <div className={styles.messageContainer}>
        {generalErrors.map((err, index) => (
          <div key={index} className={`${styles.message} ${styles[err.type || 'error']}`}>
            {err.message}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={styles.signupForm}>
      {!googleRegistrationData && (
        <>
          {forBookingForm && (
            <div className={styles.bookingFormHeader}>
              <p className={styles.bookingFormTitle}>
                {t("modal.register.bookingFormTitle")}
              </p>
            </div>
          )}
          
          <div className={styles.googleSignupSection}>
            {forBookingForm && (
              <p className={styles.googleSignupLabel}>
                {t("modal.register.signupGoogleLabel")}
              </p>
            )}
            <div className={styles.googleSignupContainer}>
              <button 
                onClick={handleGoogleSignupClick} 
                className={styles.googleSignupButton} 
                disabled={loading} 
                type="button"
              >
                <svg width="18" height="18" viewBox="0 0 48 48">
                  <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
                  <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
                  <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
                  <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
                </svg>
                <span>{t("modal.register.signupGoogle")}</span>
              </button>
            </div>
          </div>
          
          <div className={styles.signupModuleSeparationBox}>
            <hr />
            <p>{t("modal.register.or")}</p>
            <hr />
          </div>
          
          {forBookingForm && (
            <div className={styles.emailSignupLabel}>
              <p className={styles.emailSignupText}>
                {t("modal.register.emailSignupLabel")}
              </p>
            </div>
          )}
        </>
      )}

      {googleRegistrationData && (
        <div className={styles.googleRegistrationInfo}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#1a73e8"/>
          </svg>
          <p>{t("modal.register.googlePrefilled")}</p>
        </div>
      )}

      <SignUpFormInputs
        signupInputValues={inputValues}
        setSignupInputValues={handleInputChange}
        status={accountType?.value || "company"}
        errors={errors}
        setErrors={setErrors}
        onInputBlur={handleInputBlur}
        accountType={accountType}
        setAccountType={handleAccountTypeChange}
        userType={type}
        googlePrefilled={!!googleRegistrationData}
        hidePasswordFields={!!googleRegistrationData}
      />

      <Checkbox 
        label={
          <p>
            {t("modal.register.acceptTerms")}{" "}
            <a href="/static/politique-confidentialite" target="_blank" rel="noopener noreferrer">
              {t("modal.register.Terms")}
            </a>
          </p>
        } 
        onChange={() => setCgu(!cgu)} 
        checked={cgu} 
      />
      
      <Checkbox 
        label={t("modal.register.acceptNewsletter")} 
        checked={newsletter} 
        onChange={() => setNewsletter(!newsletter)} 
      />

      {/* ADDED: Turnstile CAPTCHA Widget */}
      <div className={styles.captchaContainer}>
        <Turnstile
          ref={turnstileRef}
          siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
          onSuccess={handleCaptchaSuccess}
          onError={handleCaptchaError}
          onExpire={handleCaptchaExpire}
          options={{
            theme: 'light',
            size: 'normal',
            language: getCurrentLanguage()
          }}
        />
        {captchaError && (
          <p className={styles.captchaError}>
            {t("modal.register.captcha.error")}
          </p>
        )}
      </div>

      {renderMessages()}

      <button 
        type="submit" 
        onClick={handleSubmit} 
        className={`${styles.btn} ${styles.signup}`} 
        disabled={loading || !captchaToken}
      >
        {t("modal.register.register")}
      </button>

      {!googleRegistrationData && (
        <div className={styles.loginLink}>
          <p>
            {t("modal.register.haveAccount")}{" "}
            <a onClick={() => openModal({ content: <Login forBookingForm={forBookingForm} spaceId={spaceId} returnUrl={returnUrl} />, title: t("modal.login.title") })}>
              {t("modal.register.login")}
            </a>
          </p>
        </div>
      )}
    </div>
  );
};

export default SignupForm;